import axios from "axios"
import urlUtils from "../utils/url"

export default async (refreshToken) => {
  const url = urlUtils.getApiUrl("/api/public/token/refresh")

  const response = await axios({
    method: "get",
    url,
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      refresh_token: refreshToken,
    },
  })

  return response.data
}
